// Google Analytics tracking utility for user engagement

const PROPERTY_PAGES = [
  { path: '/management/manchester/', name: 'Manchester' },
  { path: '/management/liverpool/', name: 'Liverpool' },
  { path: '/management/london/', name: 'London' },
  { path: '/management/birmingham/', name: 'Birmingham' },
  { path: '/management/leeds/', name: 'Leeds' },
  { path: '/management/newcastle/', name: 'Newcastle' },
  { path: '/management/sheffield/', name: 'Sheffield' },
  { path: '/management/stoke-on-trent/', name: 'Stoke-on-Trent' },
  { path: '/management/chester/', name: 'Chester' },
  { path: '/management/stockport/', name: 'Stockport' },
  { path: '/management/brighton/', name: 'Brighton' },
  { path: '/management/essex/', name: 'Essex' },
  { path: '/management/oxford/', name: 'Oxford' },
  { path: '/management/bath/', name: 'Bath' },
  { path: '/management/slough/', name: 'Slough' },
  { path: '/management/southampton/', name: 'Southampton' },
];

let scrollTracked = false;
let engagementTracked = false;
let startTime = null;

function getPropertyName(pathname) {
  const page = PROPERTY_PAGES.find(p => 
    pathname.replace(/\/$/, '') === p.path.replace(/\/$/, '')
  );
  return page ? page.name : 'Unknown';
}

function trackPageView(pathname) {
  if (typeof window.gtag !== 'undefined') {
    const propertyName = getPropertyName(pathname);
    window.gtag('event', 'page_view', {
      page_title: `${propertyName} - Truestays`,
      page_location: window.location.href,
      page_path: pathname,
      property_name: propertyName,
      content_type: 'property_listing'
    });
  }
}

function trackScrollDepth() {
  if (scrollTracked) return;
  
  const scrollPercent = Math.round(
    (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100
  );
  
  if (scrollPercent >= 25 && !scrollTracked) {
    scrollTracked = true;
    const propertyName = getPropertyName(window.location.pathname);
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'scroll_depth', {
        property_name: propertyName,
        scroll_percent: 25,
        event_category: 'engagement',
        event_label: '25% scroll'
      });
    }
  }
  
  if (scrollPercent >= 50) {
    const propertyName = getPropertyName(window.location.pathname);
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'scroll_depth', {
        property_name: propertyName,
        scroll_percent: 50,
        event_category: 'engagement',
        event_label: '50% scroll'
      });
    }
  }
  
  if (scrollPercent >= 75) {
    const propertyName = getPropertyName(window.location.pathname);
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'scroll_depth', {
        property_name: propertyName,
        scroll_percent: 75,
        event_category: 'engagement',
        event_label: '75% scroll'
      });
    }
  }
  
  if (scrollPercent >= 90 && !scrollTracked) {
    scrollTracked = true;
    const propertyName = getPropertyName(window.location.pathname);
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'scroll_depth', {
        property_name: propertyName,
        scroll_percent: 90,
        event_category: 'engagement',
        event_label: '90% scroll'
      });
    }
  }
}

function trackEngagement() {
  if (engagementTracked) return;
  engagementTracked = true;
  
  const propertyName = getPropertyName(window.location.pathname);
  const timeOnPage = Date.now() - startTime;
  
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'user_engagement', {
      property_name: propertyName,
      engagement_time_msec: timeOnPage,
      event_category: 'engagement'
    });
  }
}

function trackValuationRequest(propertyName) {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'valuation_request', {
      property_name: propertyName,
      event_category: 'conversion',
      event_label: 'Free valuation submitted'
    });
  }
}

function trackLocationClick(locationName) {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'location_click', {
      location_name: locationName,
      event_category: 'navigation',
      event_label: `Clicked to ${locationName}`
    });
  }
}

function trackCTAClick(ctaType, propertyName) {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'cta_click', {
      cta_type: ctaType,
      property_name: propertyName,
      event_category: 'conversion',
      event_label: `${ctaType} clicked`
    });
  }
}

function initPropertyPageTracking(pathname) {
  startTime = Date.now();
  scrollTracked = false;
  engagementTracked = false;
  
  trackPageView(pathname);
  
  window.addEventListener('scroll', trackScrollDepth, { passive: true });
  
  window.addEventListener('beforeunload', () => {
    trackEngagement();
  });
  
  return () => {
    window.removeEventListener('scroll', trackScrollDepth);
    trackEngagement();
  };
}

export {
  initPropertyPageTracking,
  trackValuationRequest,
  trackLocationClick,
  trackCTAClick,
  PROPERTY_PAGES
};